import React from 'react';
import { Page, Text, View, StyleSheet } from '@react-pdf/renderer';


const styles = StyleSheet.create({
    container: {
        backgroundColor: '#E4E4E4',
        padding: 8,
        rotate: 90,
        width: '80%',
    },
    title: {
        color: '#212326',
        fontSize: '24px', // Adjusted size
        fontWeight: 600,
        marginBottom: '10pt', // Adjusted units
    },
    tableContainer: {
        overflowY: 'auto',
        border: '1pt solid #c4c4c4', // Adjusted units
        WebkitOverflowScrolling: 'touch', // Add vendor prefixes if needed
    },
    table: {
        display: 'table',
        width: 'auto',
        borderStyle: 'solid',
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
    },
    tableRow: { margin: 'auto', flexDirection: 'row' },
    tableCell: {
        width: "20%",
        borderStyle: 'solid',
        borderWidth: 1,
        textAlign: 'center',
        padding: 8,
    },
    avatar: {
        height: '16pt', // Adjusted units
        width: '16pt', // Adjusted units
        borderRadius: '8pt', // Adjusted units
        marginRight: '4pt', // Adjusted units
        marginLeft: '1pt', // Adjusted units
    },
});
const GetProductivity = (jobs) => {
    const filteredList = jobs.filter((obj) => obj.type === "task");

    const groupedData = filteredList.reduce((acc, obj) => {
        const { accountable, status, duration, start, end } = obj;
        const accountId = accountable?.userId;

        // Convert the start and end time strings to Date objects
        const startTime = new Date(start);
        const endTime = new Date(end);

        // Calculate the difference in hours between start and end times
        let hoursToFinish = (endTime - startTime) / (1000 * 60 * 60); // Convert milliseconds to hours

        // Ensure a minimum time of 1 hour for task completion
        hoursToFinish = Math.max(hoursToFinish, 1);

        if (!acc[accountId]) {
            acc[accountId] = {
                accountable: accountable,
                done: 0,
                doneLate: 0,
                pending: 0,
                totalHoursToFinish: 0,
                totalExpectedHours: 0,
            };
        }

        acc[accountId][status]++;
        if (status === "done" || status === "doneLate") {
            acc[accountId].totalHoursToFinish += hoursToFinish;
            acc[accountId].totalExpectedHours += duration.number;
        }

        return acc;
    }, {});
    return groupedData;
};


const ProductivityPDF = ({ jobs }) => {


    const productivity = GetProductivity(jobs);
    const usernames = Object.keys(productivity).map(id => {
        const item = productivity[id]
        return item.accountable ?
            `${item.accountable.username}` : "-"
    });



    return (
        <Page size="A2">
            <View style={styles.container}>
                <Text style={styles.title}>Resumo de Produtividade</Text>
                <View style={styles.tableContainer}>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <Text style={styles.tableCell}>Colaborador</Text>
                            <Text style={styles.tableCell}>Concluídas</Text>
                            <Text style={styles.tableCell}>Atrasadas</Text>
                            <Text style={styles.tableCell}>Pendentes</Text>
                            <Text style={styles.tableCell}>Produtividade</Text>
                        </View>
                        {Object.keys(productivity).map((accountId, i) => {
                            const item = productivity[accountId];
                            return (
                                <View style={styles.tableRow} key={accountId}>
                                    <Text style={styles.tableCell}>
                                        {usernames[i]}
                                    </Text>
                                    <Text style={styles.tableCell}>{item.done}</Text>
                                    <Text style={styles.tableCell}>{item.doneLate}</Text>
                                    <Text style={styles.tableCell}>{item.pending}</Text>
                                    <Text style={styles.tableCell}>
                                        {
                                            item.totalHoursToFinish === 0
                                                ? 0
                                                : Math.min(
                                                    Math.floor(
                                                        (1 /
                                                            (item.totalHoursToFinish /
                                                                item.totalExpectedHours)) *
                                                        100
                                                    ),
                                                    999
                                                ) + '%'
                                        }
                                    </Text>
                                </View>
                            );
                        })}
                    </View>
                </View>
            </View>
        </Page>
    );
};

export default ProductivityPDF;
